/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    //bogos table style fix
const startTime = Date.now();

const interval = setInterval(() => {
  const el = document.querySelector('.bogos-volume-discount-table-container');

  // ✅ Found → apply style and stop
  if (el) {
    el.style.setProperty('border', 'none', 'important');
    clearInterval(interval);
    console.log('Bogos element found — interval stopped');
    return;
  }

  // ⏱ Stop after 10 seconds
  if (Date.now() - startTime > 10000) {
    clearInterval(interval);
    console.log('Bogos element not found — stopped after timeout');
  }

}, 300);

    //end bogos fix






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
